import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Sollulive Gestion", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Connexion", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          placeholder: "Identifiant",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.email) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.user.email]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          placeholder: "Mot de passe",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.user.password]
        ]),
        _hoisted_2
      ])
    ], 32)
  ], 64))
}